import Vue from 'vue'
import firebase from 'firebase'

export default class PricingService extends Vue {

  private db = firebase.firestore()

  getProducts() {
    return this.db
      .collection('pricing')
      .where('active', '==', true)
      .get()
      .then(function (querySnapshot: any) {
        const arr: any = [];
        querySnapshot.forEach(async function (doc: any) {
          const item = doc.data();
          item.id = doc.id;
          arr.push(item);

          const priceSnap = await doc.ref.collection('prices').get();
          priceSnap.docs.forEach((doc: any) => {
            const index = arr.findIndex((i: any) => i.id === item.id)
            arr[index].prices = doc.data();
          });
        });
        return arr;
      })
  }

}